<template>
    <div>
        <div v-if="value[1] !== null && value[1] !== ''" class="item justify-between lg:flex items-center" v-for="(value, index) in Object.entries(information)" :key="index">
            <DetailObjectType :value="value"/>
        </div>
    </div>
</template>

<script>
import DetailObjectType from "@/pages/Home/ListGlobalComponents/Tabs/components/DetailObjectType";
export default {
    name: "ObjectType",
    props:{
        information:{
            type:Object,
        },
    },
    components:{
        DetailObjectType,
    }
};
</script>

<style lang="scss" scoped>

    .item{
        &:not(:last-child){
            margin-bottom: 13px;
            padding-bottom: 13px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
    }
</style>
